"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoStream = void 0;
const GeoModelCommon_1 = require("../Geo/GeoModelCommon");
class VideoStream extends GeoModelCommon_1.GeoModelCommon {
    constructor(params) {
        super({ type: 'VideoStream', ...params });
    } // add any VideoStream specific properties here
}
exports.VideoStream = VideoStream;
